import React, { useEffect, useState } from "react";
import "./checkout.css";
// import Axios from "../../config/Axios";
import { useHistory, useLocation } from "react-router-dom";
import { Button, CircularProgress } from "@material-ui/core";
import CheckCircleIcon from '@material-ui/icons/CheckCircle';
import CancelIcon from '@material-ui/icons/Cancel';
import { checkoutPayment, validatePayment } from '../../actions/userActions';
import { useDispatch, useSelector } from 'react-redux';

function Checkout() {
  const history = useHistory();
  const location = useLocation();
  const dispatch = useDispatch();
  const [redirectUrl, setRedirectUrl] = useState("");
  const [isSuccess, setIsSuccess] = useState(true);
  const [successMessage, setSuccessMessage] = useState("");

  const paymentCheckout = useSelector(state => state.paymentCheckout);
  const { loading: loadingCheckout, error: errorCheckout, checkoutInfo } = paymentCheckout;

  const paymentValidate = useSelector(state => state.paymentValidate);
  const { loading: loadingValidate, error: errorValidate, validateInfo } = paymentValidate;

  useEffect(() => {
    if (validateInfo) {
      if (validateInfo.success) {
        setIsSuccess(true);
        setSuccessMessage("Your payment has been successfully recieved")
      } else {
        setIsSuccess(false);
        setSuccessMessage(`Sorry, we could not process your payment due to some technical issues.`)
      }

    }

    if (checkoutInfo) {
      setRedirectUrl(checkoutInfo.url);
    }
  }, [checkoutInfo, validateInfo])

  useEffect(async () => {
    let value = location.search?.split("&");
    let sessionId = value[1]?.split("=")[1];
    let orderId = value[2]?.split("=")[1];
    // let sessionId = 'cs_test_a1n7bMOeRQaPiTku5T8Y3KPVaQVSPr1cIRQmj8RyRd5LZ5GtHPpIzW6Mp6';
    // let orderId = '613eff92f4634a00167b8eae';
    if (sessionId && orderId) {
      dispatch(validatePayment(sessionId, orderId));
      // await Axios.post(
      //   "user/payment/validate",
      //   {
      //     sessionId: sessionId,
      //     orderId: orderId,
      //   },
      //   {
      //     headers: {
      //       Authorization:
      //         "Bearer eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJ1c2VyIjp7Il9pZCI6IjYwZDFmNGQxMjkwZWU4NDRlODU5MjBlOCIsIm5hbWUiOiJBaG1hZCBBc2hyYWYifSwiaWF0IjoxNjI2MjAwNjU3fQ.u0glyJpdtu4FIjEk9ol6qi41YwqpKwtU3wW6mADpBbA",
      //     },
      //   }
      // )
      //   .then(function (response) {
      //     history.push("/home");
      //     alert(response.data.message);
      //   })
      //   .catch(function (error) { });
    } else {
      dispatch(checkoutPayment("60d1f0a102324f427c512343"));
      // await Axios.post(
      //   "user/payment/checkout",
      //   {
      //     planId: "60d1f0a102324f427c512343",
      //   },
      //   {
      //     headers: {
      //       Authorization:
      //         "Bearer eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJ1c2VyIjp7Il9pZCI6IjYwZDFmNGQxMjkwZWU4NDRlODU5MjBlOCIsIm5hbWUiOiJBaG1hZCBBc2hyYWYifSwiaWF0IjoxNjI2MjAwNjU3fQ.u0glyJpdtu4FIjEk9ol6qi41YwqpKwtU3wW6mADpBbA",
      //     },
      //   }
      // )
      //   .then(function (response) {
      //     console.log(response.data.url);
      //     setRedirectUrl(response.data.url);
      //   })
      //   .catch(function (error) { });
    }
  }, []);

  return (
    validateInfo ? (
      <div className='validate_body' >
        {loadingValidate ? <CircularProgress /> : errorValidate ? (
          <h4>{errorValidate}</h4>
        ) : (
          <div>
            <div
              style={{
                display: "flex",
                justifyContent: "center",
                margin: "2rem 0",
                textAlign: "center"
              }}
            >
              {isSuccess ? <CheckCircleIcon style={{ fontSize: "10vh", color: "#59CA3F" }} /> : <CancelIcon style={{ fontSize: "10vh", color: "red" }} />}
            </div>
            <div
              style={{
                display: "flex",
                justifyContent: "center",
                margin: "2rem 0",
                textAlign: "center"
              }}
            >
              <h2>{isSuccess ? "Thank You !" : "Oops !"}<br />
                {successMessage}<br />
                {!isSuccess && 'Please try again'}</h2>
            </div>
            <div
              style={{
                display: "flex",
                justifyContent: "center",
                margin: "2rem 0",
                textAlign: "center"
              }}
            >
              <Button
                disableRipple={true}
                disableFocusRipple={true}
                variant="outlined"
                size="small"
                onClick={() => history.push('/home')}
                className="hover__backgroundchange__buttons"
              >
                Back to Dashboard
              </Button>
            </div>
          </div>
        )}
      </div>
    ) : (
      <div className="checkout">
        <div className="checkout__body">
          <h2 style={{ textAlign: "center" }}>Professional</h2>
          <div className="plan__value">
            <span style={{ fontSize: "1.875rem" }}>$</span>
            <span style={{ fontSize: "3.125rem" }}>500</span>
            <span style={{ fontSize: "1.125rem" }}>/user</span>
          </div>
          <div className="plan__coins__value"> 5000 coins
          </div>
          {/* {successMessage && (
            <h3 style={{ textAlign: "center", marginBottom: "10px" }}>{successMessage}</h3>
          )} */}
          <div className="plan__features__container">
            <p>
              <i className="fas fa-check-circle"></i>{" "}
              Feature:Feature One Description
            </p>
            <p>
              <i className="fas fa-check-circle"></i>{" "}
              Feature:Feature Two Description
            </p>
            <p>
              <i className="fas fa-check-circle"></i>{" "}
              Feature:Feature Three Description
            </p>
            <p>
              <i className="fas fa-check-circle"></i>{" "}
              Feature:Feature Four Description
            </p>
          </div>
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              margin: "2rem 0",
              textAlign: "center"
            }}
          >
            {loadingCheckout ? <CircularProgress /> : errorCheckout ? (
              <h4>{errorCheckout}</h4>
            ) : (
              <Button
                disableRipple={true}
                disableFocusRipple={true}
                variant="outlined"
                size="small"
                onClick={(e) => {
                  e.preventDefault();
                  window.location.href = redirectUrl;
                }}
                className="hover__backgroundchange__buttons"
              >
                Pay Now
              </Button>
            )}
          </div>
        </div>
      </div>
    )
  );
}

export default Checkout;
